/* Ginza footer 1.1.0 · mobile accordions (< 768px), one open at a time. */
if (!customElements.get('ginza-footer')) {
  class GinzaFooter extends HTMLElement {
    connectedCallback() {
      this.mq = window.matchMedia('(max-width: 767.98px)');
      this.items = [...this.querySelectorAll('[data-acc]')].map((el) => ({
        el,
        btn: el.querySelector('.ginza-footer__acc-btn'),
        panel: el.querySelector('.ginza-footer__acc-panel'),
        openByDefault: el.hasAttribute('data-open-mobile'),
      }));

      this.onClick = (event) => {
        const btn = event.target.closest('.ginza-footer__acc-btn');
        if (!btn || !this.mq.matches) return;
        const item = this.items.find((i) => i.btn === btn);
        if (!item) return;
        const open = btn.getAttribute('aria-expanded') !== 'true';
        if (open) this.items.forEach((i) => i !== item && this.setOpen(i, false));
        this.setOpen(item, open);
      };
      this.onChange = () => this.applyMode();
      this.onBlockSelect = (event) => {
        if (!this.mq.matches) return;
        const item = this.items.find((i) => i.el.contains(event.target) || i.el === event.target);
        if (!item) return;
        this.items.forEach((i) => this.setOpen(i, i === item));
      };

      this.addEventListener('click', this.onClick);
      this.mq.addEventListener('change', this.onChange);
      document.addEventListener('shopify:block:select', this.onBlockSelect);
      this.applyMode();
    }

    disconnectedCallback() {
      this.removeEventListener('click', this.onClick);
      this.mq.removeEventListener('change', this.onChange);
      document.removeEventListener('shopify:block:select', this.onBlockSelect);
    }

    setOpen(item, open) {
      item.btn.setAttribute('aria-expanded', String(open));
      item.panel.classList.toggle('is-collapsed', !open);
    }

    applyMode() {
      const mobile = this.mq.matches;
      this.items.forEach((item) => {
        if (mobile) {
          item.btn.removeAttribute('tabindex');
          item.btn.removeAttribute('aria-disabled');
          this.setOpen(item, item.openByDefault);
        } else {
          /* Desktop / tablet: columns are always open, the button is only a heading. */
          item.btn.setAttribute('tabindex', '-1');
          item.btn.setAttribute('aria-disabled', 'true');
          this.setOpen(item, true);
        }
      });
    }
  }

  customElements.define('ginza-footer', GinzaFooter);
}
